export const useMessage = () => {
  const toast = useToastApp()

  const showError = (message?: string, title?: string): boolean => {
    toast.$showError(message, title)
    return false
  }

  const showMessage = (message?: string, title?: string): boolean => {
    toast.$showMessage(message, title)
    return true
  }

  const showWarning = (message?: string, title?: string): boolean => {
    toast.$showWarning(message, title)
    return true
  }

  return { showError, showMessage, showWarning }
}
